










import Vue from "vue";

export default Vue.component('AddItemHyperlink', {
  props: {
    canAdd: {
      type: Boolean,
      defaultValue: true
    },
    linkText: {
      type: String,
      required: true
    }
  },
  methods: {
    addNew() {
      this.$emit('add-new');
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/AddItemHyperlink.vue